import { jsx as t, jsxs as _, Fragment as L } from "react/jsx-runtime";
import { Stack as j, Typography as Q, Alert as X, AlertTitle as Y, Table as Z, TableBody as ee, TableRow as te, TableCell as G, Popover as ne } from "@mui/material";
import { rubrics as H } from "../../queries/assessment/rubrics/index.js";
import { DaymapSkeleton as J } from "../skeletons/index.js";
import { TableComponent as q } from "../table/table.js";
import { useState as A, useEffect as ie } from "react";
import { g as re, b as z, D as U, c as ae, d as se } from "../../pointsGraph-DTJju-rA.js";
import { RubricType as K } from "../../helpers/daymaptypes.js";
import '../../assets/Rubrics.css';const oe = "_Rubrics_1r9ob_1", ce = "_Rating_1r9ob_4", le = "_Editable_1r9ob_13", de = "_PlusButton_1r9ob_20", ue = "_MinusButton_1r9ob_20", fe = "_Active_1r9ob_46", pe = "_Selected_1r9ob_60", he = "_SelfMark_1r9ob_60", ge = "_Highlight_1r9ob_66", me = "_StaffSuffix_1r9ob_76", Se = "_SelfSelectedIcon_1r9ob_83", be = "_SummaryTable_1r9ob_98", Me = "_Student_1r9ob_98", S = {
  Rubrics: oe,
  Rating: ce,
  Editable: le,
  PlusButton: de,
  MinusButton: ue,
  Active: fe,
  Selected: pe,
  SelfMark: he,
  Highlight: ge,
  StaffSuffix: me,
  SelfSelectedIcon: Se,
  SummaryTable: be,
  Student: Me
}, $e = ({ rubricId: u, taskId: n, studentId: p }) => {
  const { data: a, isPending: d } = new H.StudentRubricResults({ taskId: n, studentId: p }).ToQuery(), { data: r, isPending: b } = new H.Rubrics({ rubricId: u }).ToQuery();
  if (d || b)
    return /* @__PURE__ */ t(J, { type: "listitems" });
  const { Criteria: w } = r;
  return /* @__PURE__ */ t(j, { gap: 5, children: w.map((f) => {
    const M = [...f.Descriptors.sort((l, k) => l.RatingIndex - k.RatingIndex)], x = [{ id: "descriptor", header: "The student work has the following characteristics:" }, { id: "marks", header: "Marks" }], $ = M.filter((l) => {
      var k;
      return (k = l.Sections) == null ? void 0 : k.some((m) => m.Text.length > 0);
    }).map((l) => {
      const k = l.Sections && [...l.Sections.sort((m, i) => m.SectionIndex - i.SectionIndex)];
      return {
        descriptor: /* @__PURE__ */ t("ul", { children: k && k.map((m) => {
          const i = a == null ? void 0 : a.Sections[`${l.DescriptorID}_${m.SectionIndex}`], s = typeof i == "string" && i.length === 0;
          let y = m.Text;
          if (i && !s) {
            const I = JSON.parse(i);
            y = /* @__PURE__ */ t(Re, { className: S.Highlight, highlights: I.map((o) => ({ start: o.startMeta.textOffset, end: o.endMeta.textOffset })), children: m.Text });
          }
          return /* @__PURE__ */ t("li", { children: /* @__PURE__ */ t("div", { className: s ? S.Selected : void 0, children: y }) }, m.SectionIndex);
        }) }, l.DescriptorID),
        marks: /* @__PURE__ */ t(Q, { children: l.Mark })
      };
    }), g = a == null ? void 0 : a.Marks.find((l) => l.CriteriaID === f.CriteriaID);
    return /* @__PURE__ */ _(j, { gap: 2, children: [
      /* @__PURE__ */ t(Q, { variant: "h3", children: f.Criteria }),
      /* @__PURE__ */ t(Q, { variant: "caption", sx: { whiteSpace: "pre-line" }, children: f.Content }),
      /* @__PURE__ */ t(q, { className: S.Rubrics, rows: $, columns: x, size: "small" }),
      /* @__PURE__ */ _(Q, { alignSelf: "flex-end", children: [
        g == null ? void 0 : g.Mark,
        "/",
        f.MaxMark
      ] })
    ] });
  }) });
}, V = (u, n = null, p = !1, a, d, r) => {
  const { Ratings: b, Criteria: w, GroupCriteria: f } = u, M = b && [...b].sort((i, s) => i.RatingIndex - s.RatingIndex), x = [...w].sort((i, s) => i.CriteriaIndex - s.CriteriaIndex), $ = [
    { id: "Criteria", header: "" }
  ];
  M && M.forEach((i) => $.push({ id: i.RatingIndex, header: i.Rating })), $.push({ id: "Mark", header: "Mark" });
  let g, l, k, m = [];
  return x.forEach((i) => {
    var y;
    let s = {
      Criteria: i.Criteria,
      CriteriaID: i.CriteriaID,
      MaxMark: i.MaxMark,
      span: 0
    };
    if (m.push(s), u.RubricType === K.Rubric) {
      b.forEach((o) => {
        var P, N;
        const e = i.Descriptors.find((c) => c.RatingIndex === o.RatingIndex), T = (c) => c.DescriptorID === (e == null ? void 0 : e.DescriptorID) && c.RatingIndex === o.RatingIndex, E = e != null && e.DescriptorID ? `${e.DescriptorID}_${o.RatingIndex}` : "", R = E && (a == null ? void 0 : a.get(E));
        let v = n == null ? void 0 : n.Marks.some(T), B = p ? !!R : n == null ? void 0 : n.SelfMarks.some((c) => c.DescriptorID === (e == null ? void 0 : e.DescriptorID) && c.RatingIndex === o.RatingIndex), C = "", D = R && typeof R != "string" ? R.suffix : "";
        if (v || B) {
          const c = n == null ? void 0 : n.Marks.find(T), h = n == null ? void 0 : n.SelfMarks.find(T);
          if ((h != null && h.Mark || c != null && c.Mark) && f && i.Criteria.length === 0 ? (c != null && c.Mark && (g = typeof g == "number" ? g + c.Mark : c.Mark), h != null && h.Mark && (l = typeof l == "number" ? l + h.Mark : h.Mark)) : (k = i.CriteriaID, c != null && c.Mark && (g = c.Mark), h != null && h.Mark && (l = h.Mark)), !u.GroupCriteria) {
            if (c) {
              switch (c.Mark - c.RatingMark) {
                case 1:
                  C = "+";
                  break;
                case -1:
                  C = "-";
                  break;
              }
              s.Rating = `${(P = M.find((F) => F.RatingIndex === c.RatingIndex)) == null ? void 0 : P.Rating}${C}`;
            }
            if (h) {
              switch (h.Mark - h.RatingMark) {
                case 1:
                  D = "+";
                  break;
                case -1:
                  D = "-";
                  break;
              }
              s.SelfRating = `${(N = M.find((F) => F.RatingIndex === h.RatingIndex)) == null ? void 0 : N.Rating}${D}`;
            }
          }
        }
        s[o.RatingIndex] = /* @__PURE__ */ t(
          O,
          {
            text: e == null ? void 0 : e.Text,
            staffSelected: v,
            studentSelected: B,
            staffSuffix: C,
            studentSuffix: D,
            editable: p,
            onClick: e && p && d ? () => d(e.DescriptorID, o.RatingIndex, Number(e.Mark), i.MaxMark, !!B, i.CriteriaID) : void 0,
            onPlusClick: e && p && r ? () => r(e.DescriptorID, o.RatingIndex, Number(e.Mark), i.MaxMark, "+", i.CriteriaID) : void 0,
            onMinusClick: e && p && r ? () => r(e.DescriptorID, o.RatingIndex, Number(e.Mark), i.MaxMark, "-", i.CriteriaID) : void 0
          }
        );
      });
      const I = m.find((o) => o.CriteriaID === k);
      I && (I.span = I.span + 1, I.Mark = I.MaxMark ? `${g ? `${g}/` : ""}${I.MaxMark}` : "", I.SelfMark = I.MaxMark ? `${l ? `${l}/` : ""}${I.MaxMark}` : "");
    } else if (u.RubricType === K.ISMG) {
      const I = m.find((o) => o.CriteriaID === i.CriteriaID);
      I && (I.Mark = (y = n == null ? void 0 : n.Marks.find((o) => o.CriteriaID === i.CriteriaID)) == null ? void 0 : y.Mark);
    }
  }), { columns: $, rows: m };
}, ve = ({ rubricId: u, studentId: n, taskId: p }) => {
  const { data: a, isPending: d } = new H.StudentRubricResults({ taskId: p, studentId: n }).ToQuery(), { data: r, isPending: b } = new H.Rubrics({ rubricId: u }).ToQuery();
  if (d || b)
    return null;
  const { rows: w } = V(r, a), f = (r == null ? void 0 : r.RubricType) === K.Rubric && (r == null ? void 0 : r.GroupCriteria) == !1;
  return /* @__PURE__ */ t(Z, { size: "small", "aria-label": "Rubric summary", sx: { width: "auto", borderCollapse: "separate", borderSpacing: 0 }, className: S.SummaryTable, children: /* @__PURE__ */ t(ee, { children: w.filter((M) => M.Criteria).map((M, x) => /* @__PURE__ */ _(te, { children: [
    /* @__PURE__ */ t(G, { children: M.Criteria }),
    !f && /* @__PURE__ */ t(G, { children: M.Mark }),
    f && /* @__PURE__ */ t(G, { children: M.Rating }),
    !!(a != null && a.SelfMarks.length) && /* @__PURE__ */ _(L, { children: [
      !f && /* @__PURE__ */ t(G, { className: `${S.Student}`, children: M.SelfMark }),
      f && /* @__PURE__ */ _(G, { className: `${S.Student}`, children: [
        M.SelfRating,
        x === w.length - 1 && /* @__PURE__ */ t(W, {})
      ] })
    ] })
  ] })) }) });
}, Ce = ({ taskId: u, studentId: n, rubricId: p, sx: a, editable: d = !1, onRubricChange: r }) => {
  const { data: b, isPending: w } = new H.StudentRubricResults({ taskId: u, studentId: n }).ToQuery(), { data: f, isPending: M } = new H.Rubrics({ rubricId: p }).ToQuery(), [x, $] = A(/* @__PURE__ */ new Map()), [g, l] = A(!1), [k, m] = A(!1);
  if (ie(() => {
    l(!1), m(!1), $(/* @__PURE__ */ new Map());
  }, [b, f, u, n, p]), d && !g && !k && b && f) {
    const o = /* @__PURE__ */ new Map();
    b.SelfMarks && b.SelfMarks.length > 0 && b.SelfMarks.forEach((e) => {
      const T = f.Criteria.find(
        (E) => E.Descriptors.some((R) => R.DescriptorID === e.DescriptorID)
      );
      if (T) {
        const E = `${e.DescriptorID}_${e.RatingIndex}`;
        let R = "";
        e.Mark > e.RatingMark ? R = "+" : e.Mark < e.RatingMark && (R = "-"), o.set(E, {
          descriptorId: e.DescriptorID,
          ratingIndex: e.RatingIndex,
          mark: e.Mark,
          suffix: R,
          criteriaId: T.CriteriaID
        });
      }
    }), $(o), l(!0);
  }
  if (w || M)
    return /* @__PURE__ */ t(J, { type: "listitems" });
  const i = async (o, e, T, E, R, v) => {
    if (!d) return;
    k || m(!0);
    const B = `${o}_${e}`, C = new Map(x);
    let D = !0;
    if (R)
      r && (D = await r(v, null, e, 0, "") !== !1), D && C.delete(B);
    else if (r && (D = await r(v, o, e, T, "") !== !1), D) {
      for (const [P, N] of x.entries())
        N.criteriaId === v && C.delete(P);
      C.set(B, { descriptorId: o, ratingIndex: e, mark: T, suffix: "", criteriaId: v });
    }
    D && $(C);
  }, s = async (o, e, T, E, R, v) => {
    if (!d) return;
    k || m(!0);
    const B = `${o}_${e}`, C = x.get(B), D = new Map(x);
    let P = T;
    R === "+" ? P = Math.min(T + 1, E) : R === "-" && (P = Math.max(T - 1, 0));
    const N = C && C.suffix === R;
    let c = !0;
    if (r && (N ? c = await r(v, null, e, 0, "") !== !1 : c = await r(v, o, e, P, R) !== !1), c) {
      for (const [h, F] of x.entries())
        F.criteriaId === v && D.delete(h);
      N ? D.delete(B) : D.set(B, { descriptorId: o, ratingIndex: e, mark: P, suffix: R, criteriaId: v }), $(D);
    }
  }, { columns: y, rows: I } = V(f, b, d, x, i, s);
  return /* @__PURE__ */ t(q, { columns: y, rows: I, isPending: !1, numSticky: 1, sx: { ...a }, className: S.Rubrics, size: "small" });
}, O = ({ text: u, staffSelected: n, studentSelected: p, staffSuffix: a, studentSuffix: d, editable: r, onClick: b, onPlusClick: w, onMinusClick: f }) => {
  const [M, x] = A(!1), [$, g] = A(!1), l = a === "+" ? z.RubricRatingPlus : a === "-" ? z.RubricRatingMinus : null, k = (s) => {
    const y = s.target;
    y.closest(`.${S.PlusButton}`) || y.closest(`.${S.MinusButton}`) || b == null || b();
  }, m = r && (M || $) && u;
  return /* @__PURE__ */ _(
    "div",
    {
      className: `${S.Rating} ${n ? S.Selected : ""} ${p ? S.SelfMark : ""} ${r ? S.Editable : ""}`,
      onClick: k,
      onMouseEnter: () => r && x(!0),
      onMouseLeave: () => x(!1),
      onFocus: () => r && g(!0),
      onBlur: (s) => {
        s.currentTarget.contains(s.relatedTarget) || g(!1);
      },
      style: { cursor: r ? "pointer" : "default" },
      children: [
        u,
        p && /* @__PURE__ */ t(W, { suffix: d }),
        l && /* @__PURE__ */ t(
          U,
          {
            iconType: l,
            className: S.StaffSuffix,
            fontSize: "large"
          }
        ),
        m && /* @__PURE__ */ _(L, { children: [
          /* @__PURE__ */ t(
            "button",
            {
              type: "button",
              className: `${S.PlusButton} ${d === "+" ? S.Active : ""}`,
              onClick: (s) => {
                s.stopPropagation(), w == null || w();
              },
              onFocus: () => g(!0),
              onBlur: (s) => {
                var y;
                (y = s.currentTarget.parentElement) != null && y.contains(s.relatedTarget) || g(!1);
              },
              "aria-label": "Add plus modifier (+1 mark)",
              children: /* @__PURE__ */ t(U, { iconType: z.RubricRatingPlus, fontSize: "small" })
            }
          ),
          /* @__PURE__ */ t(
            "button",
            {
              type: "button",
              className: `${S.MinusButton} ${d === "-" ? S.Active : ""}`,
              onClick: (s) => {
                s.stopPropagation(), f == null || f();
              },
              onFocus: () => g(!0),
              onBlur: (s) => {
                var y;
                (y = s.currentTarget.parentElement) != null && y.contains(s.relatedTarget) || g(!1);
              },
              "aria-label": "Add minus modifier (-1 mark)",
              children: /* @__PURE__ */ t(U, { iconType: z.RubricRatingMinus, fontSize: "small" })
            }
          )
        ] })
      ]
    }
  );
}, W = ({ suffix: u = "" }) => {
  const [n, p] = A(null), a = !!n, d = a ? "simple-popover" : void 0;
  return /* @__PURE__ */ _(L, { children: [
    /* @__PURE__ */ _("div", { "aria-describedby": d, className: S.SelfSelectedIcon, onClick: (r) => p(r.currentTarget), children: [
      /* @__PURE__ */ t(ae, { iconType: se.UserPen, fontSize: 15 }),
      u !== "" && /* @__PURE__ */ t(U, { sx: { fontSize: 15 }, iconType: u === "-" ? z.RubricRatingMinus : z.RubricRatingPlus })
    ] }),
    /* @__PURE__ */ t(ne, { id: d, open: a, anchorEl: n, onClose: () => p(null), anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    }, children: /* @__PURE__ */ t(Q, { sx: { p: 2 }, children: "Student's self assessed rating" }) })
  ] });
}, Re = ({ children: u, highlights: n, className: p }) => {
  const a = u.split("");
  return n.forEach((d) => {
    a[d.start] = `<span>${a[d.start]}`, a[d.end - 1] = `${a[d.end - 1]}</span>`;
  }), /* @__PURE__ */ t("div", { className: p, dangerouslySetInnerHTML: { __html: a.join("") } });
}, Pe = ({ open: u, onClose: n }) => /* @__PURE__ */ t(re, { open: u, onClose: n, children: /* @__PURE__ */ _(X, { severity: "info", children: [
  /* @__PURE__ */ t(Y, { children: "Rubric Marking" }),
  /* @__PURE__ */ t("p", { children: "Rubric ratings can be selected by staff and where permitted students can also enter their own predicted ratings." }),
  /* @__PURE__ */ _(j, { gap: 3, p: 2, children: [
    /* @__PURE__ */ t(O, { text: /* @__PURE__ */ _("span", { children: [
      "Ratings ",
      /* @__PURE__ */ t("b", { children: "marked only by a teacher" }),
      " will have a yellow background with no border"
    ] }), staffSelected: !0 }),
    /* @__PURE__ */ t(O, { text: /* @__PURE__ */ _("span", { children: [
      "Ratings ",
      /* @__PURE__ */ t("b", { children: "predicted by the student" }),
      " but not marked by the teacher will have a blue border with no background"
    ] }), studentSelected: !0 }),
    /* @__PURE__ */ t(O, { text: /* @__PURE__ */ _("span", { children: [
      "Ratings ",
      /* @__PURE__ */ t("b", { children: "predicted by the student and also marked by the teacher" }),
      " will have a blue border with a yellow background"
    ] }), staffSelected: !0, studentSelected: !0 })
  ] })
] }) });
export {
  $e as Ismg,
  Pe as MarkingInfo,
  ve as RubricSummary,
  Ce as RubricTable
};
//# sourceMappingURL=Rubrics.js.map
